import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";

export default function ResetPassword() {
  const { t, formatError } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("reset_password"));
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex items-center justify-between px-6 pt-6">
        <Link to="/login" className="eyebrow hover:text-[color:var(--cu-gold-light)]">← {t("back_to_sign_in")}</Link>
        <LangToggle />
      </header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-sm fade-up">
          <Logo size="md" />
          <h1 className="font-serif-cu text-2xl text-center mt-10 mb-8">{t("reset_password")}</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="eyebrow block mb-2">{t("new_password")}</label>
              <input data-testid="reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="cu-input w-full px-4 py-3 text-sm" autoComplete="new-password" />
            </div>
            {error && <p data-testid="reset-error" className="text-xs text-red-400">{error}</p>}
            <button data-testid="reset-submit-button" disabled={loading || !token} className="btn-gold w-full py-3.5 text-sm">{t("reset_password")}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
